export class AffectedScenarioInput {
  name: string;
  originalValue: number;
  updatedValue: number;

  constructor(name: string, originalValue: number, updatedValue: number) {
    this.name = name;
    this.originalValue = originalValue;
    this.updatedValue = updatedValue;
  }
}
